import { useMutation, useQueryClient } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Agregar etiqueta a un ticket (por nombre nuevo o etiqueta_id existente).
// Invalida el detalle (refresca ticket.etiquetas) y el catalogo de etiquetas.
export const useAgregarEtiqueta = (headquarter, id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ etiquetaId, nombre }) =>
      ticketsService.agregarEtiqueta({ headquarter, id, etiquetaId, nombre }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ticketsKeys.detalle(headquarter, id) });
      qc.invalidateQueries({ queryKey: ticketsKeys.etiquetas(headquarter) });
    },
  });
};

// Quitar etiqueta de un ticket.
export const useQuitarEtiqueta = (headquarter, id) => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (etiquetaId) => ticketsService.quitarEtiqueta({ headquarter, id, etiquetaId }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ticketsKeys.detalle(headquarter, id) }),
  });
};
